import React from 'react'
import {DefaultProps, RefTable, Validator} from "./RefTable";


export const MonthlyExchangeRatesGBP = (props)=><RefTable {...props}/>;



MonthlyExchangeRatesGBP.defaultProps = {
    ...DefaultProps,
    tableName: "exchange_rates_per_month_gbp",
    tableSchema: "exchange_rates_per_month_gbp",
    edit: true,
    title: "Monthly Exchange Rates GBP",
    theadHeight: 40,
    validator: {
        to_gbp_rate: new Validator("to_gbp_rate", async (value)=> {
            if(value <= 0 )
                return Promise.reject("Exchange rate cannot be zero or negative")
        })
    },
}
